import Logo from '../logo/Logo.js';
import Search from '../search/Search.js';
import NumResults from '../numResults/NumResults.js';

import './navbar.scss';

function NavBar({ query, onQuery, movies }) {
  return (
    <nav className='nav-bar'>
      <div className='nav-bar__box container'>
        <div className='nav-bar__logo'>
          <Logo />
        </div>
        <div className='nav-bar__search'>
          <Search query={query} onQuery={onQuery} />
        </div>
        <div className='nav-bar__numreults'>
          <NumResults movies={movies} query={query} />
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
